import { useMemo } from "react";
import { useLocation } from "react-router-dom";
// contexts
import { AuthProvider } from "./AuthContext";
import { AutomationsProvider } from "./AutomationsContext";
import { ProductsProvider } from "./ProductsContext";
import { OrdersProvider } from "./OrdersContext";
import { SettingsProvider } from "./SettingsContext";
import { ShopProvider } from "./ShopContext";
import { StatsProvider } from "./StatsContext";
import { BISNotificationsProvider } from "./BackInStockContext";
import { IntegrationsProvider } from "./IntergrationsContext";
import { SellingPlansProvider } from "./SellingPlansContext";
import { ActivityLogsProvider } from "./ActivityLogsContext";
import { AutomationTagsProvider } from "./AutomationTagsContext";
// constants
import { APP_ROUTES } from "../common/constants";

const SKIP_INIT_CONTEXTS_ROUTES = [APP_ROUTES.CUSTOMERS];

const combineProviders = (...components) => {
  return components.reduce(
    (AccumulatedProvider, CurrentProvider) => {
      return ({ children }) => {
        return (
          <AccumulatedProvider>
            <CurrentProvider>{children}</CurrentProvider>
          </AccumulatedProvider>
        );
      };
    },
    ({ children }) => <>{children}</>
  );
};

const providers = [
  AuthProvider,
  StatsProvider,
  ShopProvider,
  ActivityLogsProvider,
  ProductsProvider,
  SettingsProvider,
  OrdersProvider,
  AutomationsProvider,
  BISNotificationsProvider,
  IntegrationsProvider,
  SellingPlansProvider,
  AutomationTagsProvider,
];

export const Providers = combineProviders(...providers);

export const AppContextProvider = ({ children }) => {
  const { pathname } = useLocation();

  const memoizedProviders = useMemo(() => <Providers>{children}</Providers>, [children]);

  if (SKIP_INIT_CONTEXTS_ROUTES.some((route) => pathname.includes(route))) {
    return <>{children}</>;
  }

  return memoizedProviders;
};
